<div class="app-card-box w-100"
     (click)="actions.open()">
    <div class="d-flex align-items-center">
        <div>
            <img class="app-icon app-border-radius"
                 [src]="application.iconUrl">
        </div>
        <div class="px-sm py-sm">
            <div class="ts-h5-sans">{{ application.name }}</div>
        </div>
    </div>
    <div>
        <div class="ts-caption pt-sm">{{ application.description }}</div>
    </div>
</div>
<ion-select aria-label="Contatti"
            style="display: none"
            #actions
            (ionChange)="onSelectChange()"
            interface="action-sheet"
            placeholder="Contatti">
    <ion-select-option value="phone">Scarica</ion-select-option>
</ion-select>
